import * as React from 'react'

import { CtaBand } from '../../_shared/CtaBand'
import { CTA } from '../content'
import { useStatsTracking } from '../tracking'
import styles from './Cta.module.css'

/** Closing call to action — the shared band, put on this page's section rhythm. */
export function Cta(): React.ReactElement {
  const tracking = useStatsTracking()

  return (
    <CtaBand
      className={styles.cta}
      title={CTA.title}
      lede={CTA.lede}
      actions={[CTA.action]}
      onActionClick={() => tracking.ctaClick('closing')}
    />
  )
}
